import styled, { css } from "styled-components";



export const TopInfoContainer = styled.div`
    text-align: center;
    margin-bottom: 40px;
    p {
        color: #424242;
        font-size: 16px;
        margin-bottom: 20px;
    }
`;


export const FormContainer = styled.div`
    max-width: 800px;
    margin: auto;
    padding: 40px;
    background-color: #ffffff;
    box-shadow: 0px 1px 3px rgba(0,0,0,0.3);
    border-radius: 8px;
    border: 1px solid #02391E;
`;

export const FormRow = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    gap: 15px;
    @media screen and (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 5px;
        margin-bottom: 20px;
    }
`;

export const StyledLabel = styled.label`
    flex: 0 0 150px;
    text-align: right;
    color: #575757;
    font-size: 14px;
    font-weight: 500;
    @media screen and (max-width: 768px) {
        text-align: left;
        flex-basis: auto;
    }
`;

const inputStyles = css`
    width: 100%;
    height: 40px;
    border-radius: 4px;
    border: 1px solid #B6B6B6;
    color: #000000;
    padding-left: 10px;
    flex: 1;
`;

export const StyledInput = styled.input`${inputStyles}`;

export const ActionsContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    margin-top: 20px;
`;

export const CheckboxLabel = styled.label`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    cursor: pointer;
`;

export const DisclaimerText = styled.p`
    font-size: 12px;
    color: #575757;
    text-align: center;
    line-height: 1.5;
    max-width: 500px;
`;

const buttonBase = css`
    display: inline-block;
    background-color: #02391E;
    color: #ffffff;
    border-radius: 8px;
    padding: 12px 30px;
    font-weight: 600;
    text-align: center;
    cursor: pointer;
    transition: background-color 0.3s ease;
    width: 100%;
    max-width: 300px;
    box-sizing: border-box;
    text-decoration: none;

    &:hover {
        background-color: #056731;
    }
`;

export const SubmitButton = styled.button`
    ${buttonBase}
    border: none;
    margin-top: 20px;
    &:disabled {
        background-color: #cccccc;
        cursor: not-allowed;
    }
`;

export const IntegratorButton = styled.a`${buttonBase}`;

export const SuccessContainer = styled.div`
    text-align: center;
    padding: 40px 20px;
    color: #02391E;

    p {
        font-size: 18px;
        line-height: 1.6;
        margin-bottom: 30px;
    }
`;

export const SuccessActions = styled.div`
    display: flex;
    justify-content: center;
    gap: 20px;
    flex-wrap: wrap;
`;

export const SuccessButton = styled.a`${buttonBase}`;